import React from "react";
import PopUp from "../../HOC/PopUp";

export const ConsentClauseModal = ({ handleClose }) => {
  return (
    <PopUp
      popUpClassName="h-534"
      className="w-700 kfs-wrapper"
      onClose={handleClose}
    >
      <div class="modal-content">
        <div class="modal-body clearfix emi-payment-summary">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 emi-tenure-header">
          <h2>Digital Lending Consent</h2>
          </div>
          <div className="concent-container">
            <div className="concent-title">Consent Clause :</div>

            <div className="concent-section">
              <div className="concent-text">
                I/We hereby expressly authorize and give consent to ICICI Bank
                to, disclose, transfer or part with any of my/our information,
                (including location), or any other device information when ICICI
                Bank considers such disclosure as necessary, with:{" "}
              </div>
            </div>

            <div className="concent-section">
              <div className="concent-text">
                A. Agents of ICICI Bank, ICICI Bank's group entities/in any
                jurisdiction;
              </div>
              <div className="concent-text">
                B. Auditors, credit rating agencies/credit bureaus,
                statutory/regulatory authorities, governmental/administrative
                authorities, Central Know Your Customer (CKYC) registry or SEBI
                Know Your Client registration agency, having jurisdiction over
                ICICI Bank or its group entities;{" "}
              </div>
              <div className="concent-text">
                {" "}
                C. Service providers, or such person with whom ICICI Bank
                contracts or proposes to contract; (Collectively referred to as
                “Permitted Persons”){" "}
              </div>
            </div>

            <div className="concent-section">
              <div className="concent-text">For the purposes of:</div>
              <div className="concent-text">
                1. Provision of the facility and completion of on-boarding
                formalities; or{" "}
              </div>
              <div className="concent-text">
                2. Complying with KYC requirements; or{" "}
              </div>
              <div className="concent-text">
                {" "}
                3. Compliance with applicable laws or any order (judicial or
                otherwise), statutory/regulatory requirement; or{" "}
              </div>
              <div className="concent-text">
                {" "}
                4. For credit review of facilities availed; or{" "}
              </div>
              <div className="concent-text">
                5. Authentication or verification; or{" "}
              </div>
              <div className="concent-text">
                6. Research or analysis, credit reporting & scoring, risk
                management, participation in any telecommunication; or{" "}
              </div>
              <div className="concent-text">
                7. Electronic clearing network and for use or processing of the
                said information/data.{" "}
              </div>
              <div className="concent-text">
                {" "}
                8. Disclosing any default in payment, for the purposes of
                recovering such amounts.{" "}
              </div>
            </div>

            <div className="concent-text">
              D. For detailed Privacy Policy of the ICICI bank, please visit {" "}
              <a href="https://www.icicibank.com/privacy.page" target= "_blank" className="concent-doc-link">
                <u>https://www.icicibank.com/privacy.page</u>
                </a>
            </div>
          </div>
        </div>
      </div>
    </PopUp>
  );
};
